import { useQuery } from '@gogame/query';

import { loadCreativePerformance } from 'scenes/Gallery/GalleryPage/Creatives/sources/perfomance';

import { performance } from './queryKeyFactory';

export const usePerformance = (params) => {
  return useQuery(performance(params.id), (_, { signal }) =>
    loadCreativePerformance(params, { signal })
  );
};
